import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ISponsorshipImage } from "components/sponsorList/SponsorList";
import { ITournament } from "redux/reducers/models/tournament";

export type TGetTournament = {
  id?: string | number;
  ids?: Array<string> | Array<number>;
  search?: string; // Search by tournament name
  year?: number;
  month?: number;
  limit?: number;
  offset?: number;
};

export type TPostTournament = {
  name: string;
  start_time: string;
  date: string;
  end_date?: string;
  description: string;
  tournament_type: string;
};

export type TPutTournament = {
  id: string | number;

  name?: string;
  start_time?: string;
  date?: string | Date;
  end_date?: string | Date;
  description?: string;
  player_limit?: number;
  waitlist_limit?: number;
  tee_sheet_note?: string;

  registration_open_date?: string;
  registration_close_date?: string;
  display_online?: boolean;
  display_registration_online?: boolean;

  registration_enabled?: boolean;

  online_store?: boolean;

  minimum_registration_amount?: number;
  maximum_registration_amount?: number;

  tournament_type?: string;

  // registration_deadline?: Date;
  // capacity?: number;
  // logo_source?: string;
};

// GET Tournament
// Retrieve a list of tournaments
export async function GetTournament(params: TGetTournament, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<ITournament[]>(APIUrl(AdminType.FacilityAdmin, "/tournament"), params, useGlobalLoader, token);
}

// POST Tournament
// Create a new tournament
export async function PostTournament(params: TPostTournament, useGlobalLoader: boolean) {
  return await APIPost<ITournament>(APIUrl(AdminType.FacilityAdmin, "/tournament"), params, useGlobalLoader);
}

// PUT Tournament
// Update an existing tournament
export async function PutTournament(params: TPutTournament, useGlobalLoader: boolean) {
  return await APIPut<ITournament>(APIUrl(AdminType.FacilityAdmin, "/tournament"), params, useGlobalLoader);
}

// PUT Tournament
// Update an existing tournament
export async function DeleteTournament(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tournament"), params, useGlobalLoader);
}

//Tournament Logo
export async function UploadTournamentLogo(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/logo"), params, useGlobalLoader);
}

export async function DeleteTournamentLogo(params: any, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tournament/logo"), params, useGlobalLoader);
}

export async function GetTournamentSponsorship(
  params: { tournament_id?: string },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ISponsorshipImage[]>(APIUrl(AdminType.FacilityAdmin, "/tournament/sponsorship"), params, useGlobalLoader, token);
}

export async function PostTournamentSponsorship(params: FormData, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/sponsorship"), params, useGlobalLoader);
}

export async function DeleteTournamentSponsorship(params: { id: number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tournament/sponsorship"), params, useGlobalLoader);
}

//POST Add Player
// Add player to tournament
export async function AddPlayerToTournament(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/participant"), params, useGlobalLoader);
}

// GET Tournament Players
// Retrieve a list of tournament players
export async function GetTournamentPlayers(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tournament/participant"), params, useGlobalLoader, token);
}
